import { Languages } from 'lucide-react';
import { useLanguage } from '@/hooks/useLanguage';

const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="p-2 rounded-lg bg-light-secondary dark:bg-dark-secondary hover:bg-light-accent dark:hover:bg-dark-accent transition-colors flex items-center gap-2"
      aria-label="Toggle language"
    >
      <Languages size={20} className="text-light-text dark:text-dark-text" />
      <span className="text-sm font-medium text-light-text dark:text-dark-text">
        {language === 'ar' ? 'EN' : 'AR'}
      </span>
    </button>
  );
};

export default LanguageSwitcher;

